import React, {useEffect, useRef} from 'react';

import "leaflet";
import "leaflet.markercluster";
import "./css/leaflet.css";
import "./css/MarkerCluster.css";
import "./css/MarkerCluster.Default.css";


let map;
export function setupMap(data, ref, markerInfo = [])
{
	console.log("Drawin map", data, ref);
	var L = window.L;
	var L = window.L;
	if(map)
	{
		map.remove();
	}
	if(!data || data.length === 0)
	{
		console.log("DONT INIT MAPS");
		return;
	}
	console.log("INIT MAPS");
	map = L.map(ref, {
		maxBounds: new L.LatLngBounds(new L.LatLng(-90, -190), new L.LatLng(90, 190))
	}).setView(data[0], 6);


	L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
		attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
	}).addTo(map);
	map.fitBounds(data);

	var markers = L.markerClusterGroup({
		iconCreateFunction: function(cluster) {
		  var childCount = cluster.getChildCount();

		  var c = ' marker-cluster-';
		  if (childCount < 10) {
			c += 'small';
		  } else if (childCount < 100) {
			c += 'medium';
		  } else {
			c += 'large';
		  }

		  return new L.DivIcon({ html: '<div><span>' + childCount + '</span></div>', className: 'marker-cluster' + c, iconSize: new L.Point(40, 40) });
		}
	  });
	  var testIcon = L.Icon.extend({
		  options: {
			  iconSize:     [25, 41],
			  iconAnchor:   [12.5, 41],
			  shadowAnchor: [4, 62],
			  popupAnchor:  [-3, -76]
		  }
	  });
	  var icon = new testIcon({iconUrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAApCAYAAADAk4LOAAAFgUlEQVR4Aa1XA5BjWRTN2oW17d3YaZtr2962HUzbDNpjszW24mRt28p47v7zq/bXZtrp/lWnXr337j3nPCe85NcypgSFdugCpW5YoDAMRaIMqRi6aKq5E3YqDQO3qAwjVWrD8Ncq/RBpykd8oZUb/kaJutow8r1aP9II0WmLKLIsJyv1w/kqw9Ch2MYdB++12Onxee/QMwvf4/Dk/Lfp/i4nxTXtOoQ4pW5Aj7wpici1A9erdAN2OH64x8OSP9j3Ft3b7aWkTg/Fm91siTra0f9on5sQr9INejH6CUUUpavjFNq1B+Oadhxmnfa8RfEmN8VNAsQhPqF55xHkMzz3jSmChWU6f7/XZKNH+9+hBLOHYozuKQPxyMPUKkrX/K0uWnfFaJGS1QPRtZsOPtr3NsW0uyh6NNCOkU3Yz+bXbT3I8G3xE5EXLXtCXbbqwCO9zPQYPRTZ5vIDXD7U+w7rFDEoUUf7ibHIR4y6bLVPXrz8JVZEql13trxwue/uDivd3fkWRbS6/IA2bID4uk0UpF1N8qLlbBlXs4Ee7HLTfV1j54APvODnSfOWBqtKVvjgLKzF5YdEk5ewRkGlK0i33Eofffc7HT56jD7/6U+qH3Cx7SBLNntH5YIPvODnyfIXZYRVDPqgHtLs5ABHD3YzLuespb7t79FY34DjMwrVrcTuwlT55YMPvOBnRrJ4VXTdNnYug5ucHLBjEpt30701A3Ts+HEa73u6dT3FNWwflY86eMHPk+Yu+i6pzUpRrW7SNDg5JHR4KapmM5Wv2E8Tfcb1HoqqHMHU+uWDD7zg54mz5/2BSnizi9T1Dg4QQXLToGNCkb6tb1NU+QAlGr1++eADrzhn/u8Q2YZhQVlZ5+CAOtqfbhmaUCS1ezNFVm2imDbPmPng5wmz+gwh+oHDce0eUtQ6OGDIyR0uUhUsoO3vfDmmgOezH0mZN59x7MBi++WDL1g/eEiU3avlidO671bkLfwbw5XV2P8Pzo0ydy4t2/0eu33xYSOMOD8hTf4CrBtGMSoXfPLchX+J0ruSePw3LZeK0juPJbYzrhkH0io7B3k164hiGvawhOKMLkrQLyVpZg8rHFW7E2uHOL888IBPlNZ1FPzstSJM694fWr6RwpvcJK60+0HCILTBzZLFNdtAzJaohze60T8qBzyh5ZuOg5e7uwQppofEmf2++DYvmySqGBuKaicF1blQjhuHdvCIMvp8whTTfZzI7RldpwtSzL+F1+wkdZ2TBOW2gIF88PBTzD/gpeREAMEbxnJcaJHNHrpzji0gQCS6hdkEeYt9DF/2qPcEC8RM28Hwmr3sdNyht00byAut2k3gufWNtgtOEOFGUwcXWNDbdNbpgBGxEvKkOQsxivJx33iow0Vw5S6SVTrpVq11ysA2Rp7gTfPfktc6zhtXBBC+adRLshf6sG2RfHPZ5EAc4sVZ83yCN00Fk/4kggu40ZTvIEm5g24qtU4KjBrx/BTTH8ifVASAG7gKrnWxJDcU7x8X6Ecczhm3o6YicvsLXWfh3Ch1W0k8x0nXF+0fFxgt4phz8QvypiwCCFKMqXCnqXExjq10beH+UUA7+nG6mdG/Pu0f3LgFcGrl2s0kNNjpmoJ9o4B29CMO8dMT4Q5ox8uitF6fqsrJOr8qnwNbRzv6hSnG5wP+64C7h9lp30hKNtKdWjtdkbuPA19nJ7Tz3zR/ibgARbhb4AlhavcBebmTHcFl2fvYEnW0ox9xMxKBS8btJ+KiEbq9zA4RthQXDhPa0T9TEe69gWupwc6uBUphquXgf+/FrIjweHQS4/pduMe5ERUMHUd9xv8ZR98CxkS4F2n3EUrUZ10EYNw7BWm9x1GiPssi3GgiGRDKWRYZfXlON+dfNbM+GgIwYdwAAAAASUVORK5CYII='});
	  L.icon = function (options) {
		  return new L.Icon(options);
	  };
	  //console.log("Hmmm", this.props.data.length, this.props.info.length);
	  for(var i = 0; i < data.length; i++)
	  {
		  var test = L.marker(data[i], {icon: icon});
		  markers.addLayer(test);
		  const info = markerInfo[i];
		  if(info)
		  {
			  //console.log(info);
			  test.bindPopup("<b>" + info.name + "</b><br>Hos " + info.customer + " med " + info.points + " point.<br/>" + info.address);
		  }
	  }

  map.addLayer(markers);


	// map = L.map(ref).setView([51.505, -0.09], 13);
	// L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
	// 	attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
	// }).addTo(map);
	// let markers = L.markerClusterGroup();
	// for(let i = 0; i < data.length; i++)
	// {
	// 	let curr = data[i];
	// 	console.log(curr, data);
	// 	const [lat, long] = curr;
	// 	let marker = L.marker([lat, long]);
	// 	marker.bindPopup("eh");
	// 	markers.addLayer(marker);
	// }
	// map.addLayer(markers);
}

// export default function Maps(props)
// {
// 	console.log("Map??");
// 	const mapRef = useRef(null);
// 	// useEffect(() => {
// 	// 	setupMap(props.data, mapRef.current);
// 	// }, [props.data, mapRef]);
// 	return (<div ref={mapRef} style={{...props.style, backgroundColor: "rgb(204, 221, 221)"}}></div>);
// }

export default class Maps extends React.Component {
	constructor(){
		super();
	}

	componentDidMount(){

    	var L = window.L;
		var markD = this.props.data;
		const center = !this.props.data || this.props.data.length === 0 ? {
			lat: 55.506920,
			lng: 9.728400,
		} : {
			lat: markD[0][0],
			lng: markD[0][1],
		};

		var thisMap = L.map(this.refs.mapid, {
			maxBounds: new L.LatLngBounds(new L.LatLng(-90, -190), new L.LatLng(90, 190))
		}).setView(center, 6);

		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(thisMap);

	if(markD.length > 0)
	{
		thisMap.fitBounds(markD);
	}
    var markers = L.markerClusterGroup({
		  iconCreateFunction: function(cluster) {
		    var childCount = cluster.getChildCount();

		    var c = ' marker-cluster-';
		    if (childCount < 10) {
		      c += 'small';
		    } else if (childCount < 100) {
		      c += 'medium';
		    } else {
		      c += 'large';
		    }

		    return new L.DivIcon({ html: '<div><span>' + childCount + '</span></div>', className: 'marker-cluster' + c, iconSize: new L.Point(40, 40) });
		  }
		});
		var testIcon = L.Icon.extend({
		    options: {
		        iconSize:     [25, 41],
		        iconAnchor:   [12.5, 41],
		        shadowAnchor: [4, 62],
		        popupAnchor:  [-3, -76]
		    }
		});
		var icon = new testIcon({iconUrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAApCAYAAADAk4LOAAAFgUlEQVR4Aa1XA5BjWRTN2oW17d3YaZtr2962HUzbDNpjszW24mRt28p47v7zq/bXZtrp/lWnXr337j3nPCe85NcypgSFdugCpW5YoDAMRaIMqRi6aKq5E3YqDQO3qAwjVWrD8Ncq/RBpykd8oZUb/kaJutow8r1aP9II0WmLKLIsJyv1w/kqw9Ch2MYdB++12Onxee/QMwvf4/Dk/Lfp/i4nxTXtOoQ4pW5Aj7wpici1A9erdAN2OH64x8OSP9j3Ft3b7aWkTg/Fm91siTra0f9on5sQr9INejH6CUUUpavjFNq1B+Oadhxmnfa8RfEmN8VNAsQhPqF55xHkMzz3jSmChWU6f7/XZKNH+9+hBLOHYozuKQPxyMPUKkrX/K0uWnfFaJGS1QPRtZsOPtr3NsW0uyh6NNCOkU3Yz+bXbT3I8G3xE5EXLXtCXbbqwCO9zPQYPRTZ5vIDXD7U+w7rFDEoUUf7ibHIR4y6bLVPXrz8JVZEql13trxwue/uDivd3fkWRbS6/IA2bID4uk0UpF1N8qLlbBlXs4Ee7HLTfV1j54APvODnSfOWBqtKVvjgLKzF5YdEk5ewRkGlK0i33Eofffc7HT56jD7/6U+qH3Cx7SBLNntH5YIPvODnyfIXZYRVDPqgHtLs5ABHD3YzLuespb7t79FY34DjMwrVrcTuwlT55YMPvOBnRrJ4VXTdNnYug5ucHLBjEpt30701A3Ts+HEa73u6dT3FNWwflY86eMHPk+Yu+i6pzUpRrW7SNDg5JHR4KapmM5Wv2E8Tfcb1HoqqHMHU+uWDD7zg54mz5/2BSnizi9T1Dg4QQXLToGNCkb6tb1NU+QAlGr1++eADrzhn/u8Q2YZhQVlZ5+CAOtqfbhmaUCS1ezNFVm2imDbPmPng5wmz+gwh+oHDce0eUtQ6OGDIyR0uUhUsoO3vfDmmgOezH0mZN59x7MBi++WDL1g/eEiU3avlidO671bkLfwbw5XV2P8Pzo0ydy4t2/0eu33xYSOMOD8hTf4CrBtGMSoXfPLchX+J0ruSePw3LZeK0juPJbYzrhkH0io7B3k164hiGvawhOKMLkrQLyVpZg8rHFW7E2uHOL888IBPlNZ1FPzstSJM694fWr6RwpvcJK60+0HCILTBzZLFNdtAzJaohze60T8qBzyh5ZuOg5e7uwQppofEmf2++DYvmySqGBuKaicF1blQjhuHdvCIMvp8whTTfZzI7RldpwtSzL+F1+wkdZ2TBOW2gIF88PBTzD/gpeREAMEbxnJcaJHNHrpzji0gQCS6hdkEeYt9DF/2qPcEC8RM28Hwmr3sdNyht00byAut2k3gufWNtgtOEOFGUwcXWNDbdNbpgBGxEvKkOQsxivJx33iow0Vw5S6SVTrpVq11ysA2Rp7gTfPfktc6zhtXBBC+adRLshf6sG2RfHPZ5EAc4sVZ83yCN00Fk/4kggu40ZTvIEm5g24qtU4KjBrx/BTTH8ifVASAG7gKrnWxJDcU7x8X6Ecczhm3o6YicvsLXWfh3Ch1W0k8x0nXF+0fFxgt4phz8QvypiwCCFKMqXCnqXExjq10beH+UUA7+nG6mdG/Pu0f3LgFcGrl2s0kNNjpmoJ9o4B29CMO8dMT4Q5ox8uitF6fqsrJOr8qnwNbRzv6hSnG5wP+64C7h9lp30hKNtKdWjtdkbuPA19nJ7Tz3zR/ibgARbhb4AlhavcBebmTHcFl2fvYEnW0ox9xMxKBS8btJ+KiEbq9zA4RthQXDhPa0T9TEe69gWupwc6uBUphquXgf+/FrIjweHQS4/pduMe5ERUMHUd9xv8ZR98CxkS4F2n3EUrUZ10EYNw7BWm9x1GiPssi3GgiGRDKWRYZfXlON+dfNbM+GgIwYdwAAAAASUVORK5CYII='});
		L.icon = function (options) {
		    return new L.Icon(options);
		};

		const markerInfo = this.props.info;
		for(var i = 0; i < markD.length; i++)
		{
			var test = L.marker(markD[i], {icon: icon});
			markers.addLayer(test);
			if(markerInfo)
			{
				const info = markerInfo[i];
				test.bindPopup("<b>" + info.title + "</b>" + (info.link ? `<br/><a href="${info.link}" target="_blank">${info.linkText}</a>` : ''));
			}
		}

    thisMap.addLayer(markers);
	}
	render(){
		// console.log("HEHEHEHEHEEHEH");
		return (<div ref="mapid" style={{...this.props.style, backgroundColor: "rgb(204, 221, 221)"}}></div>);
	}
}

// export default Maps;


// WEBPACK FOOTER //
// ./src/components/Maps.js